export default "__VITE_ASSET__DiUW7TGG__"